import ITask from '../../../Utility/Task/ITask';
import CardSystem from '../CardSystem';
import { delay } from '../../../Utility/Task/TaskQueue';
import GameObject from '../../../GameObject/GameObject';
import Game from '../../../Game';
import { Point } from 'pixi.js';
import Container from '../../../Prototype/Container';
import { StartAnimation } from '../../Animation/AnimationHelper';
import { WinCriteriaTypeMap } from '../../../Constants/WinCriteria';
import Element from '../../../Prototype/UI/Element';
import Text from '../../../Prototype/Text';
import Sprite from '../../../Prototype/Sprite';
import { StartAudio } from '../../Audio/AudioHelper';
import { AUDIO_UI_POPUP_OPEN_DEFAULT, AUDIO_UI_POPUP_CLOSE_DEFAULT } from '../../Audio';
import { AudioTrackType } from '../../Audio/AudioClip';

export default class GoalMenuTask implements ITask<CardSystem> {
    public *execute(system: CardSystem): IterableIterator<number> {
        const goals = system.state.getState().levelState.winCriteria;

        const textKey = WinCriteriaTypeMap[goals[0].type].textKey;
        const texture = WinCriteriaTypeMap[goals[0].type].texture;

        const overlay = system.animator.getChildByName('overlay');

        const container = GameObject.Instantiate(Container, {
            relativePosition: new Point(0, 0),
        });

        const bar = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'bar',
            layout: {
                anchors: [0, -1, 1, 0],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                constrains: {
                    heightMin: 130,
                    heightMax: 130
                }
            },
            components: [{
                type: 'nineslice',
                data: {
                    cacheKey: 'bar_9_slices',
                    offset: [12, 0, 8, 0]
                }
            }]
        });

        const title = GameObject.Instantiate(Text, {
            text: Game.locale.getText(textKey),
            relativePosition: new Point(0.5, 0.08),
            scale: new Point(1, 1),
            anchor: new Point(0.5, 0.5),
            style: Game.style.getStyle('goal_bar.title'),
            bounds: new Point(550, 300)
        });

        const foxy = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'foxy',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [-400, 50, -400, 50]
            },
            components: [{
                type: 'image',
                data: {
                    cacheKey: 'goals_foxy'
                }
            }]
        });

        const iconContainer = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'icon_container',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [400, 0, 400, 0]
            },
            components: [{
                type: 'image',
                data: {
                    cacheKey: 'goals_bg'
                }
            }]
        });

        const goalIcon = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'clear_all',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0]
            },
            components: [{
                type: 'image',
                data: {
                    cacheKey: texture
                }
            }]
        });

        //

        iconContainer.addChild(goalIcon);
        bar.addChild(title);
        bar.addChild(foxy);
        bar.addChild(iconContainer);
        container.addChild(bar);

        system.scene.addGameObject(container);

        //

        StartAnimation(overlay, 'OverlayFadeIn');
        StartAnimation(bar, 'GoalBarPopIn');
        StartAudio(system.scene, AUDIO_UI_POPUP_OPEN_DEFAULT, AudioTrackType.SFX);

        yield* delay(1500);

        StartAnimation(overlay, 'OverlayFadeOut');
        StartAnimation(bar, 'GoalBarPopOut');
        StartAudio(system.scene, AUDIO_UI_POPUP_CLOSE_DEFAULT, AudioTrackType.SFX);
    }
}
